import axios from 'axios';
import {prepareUrl} from './DataSource';

const storage = window.localStorage;

const Auth = {
  isAuthenticated: false,
  ready: false,
  authToken: null,
  subscribers: [],
  email: null,
  password: null,
}

Auth.updateAuthToken = (authToken, validTill) => {
  if (authToken !== Auth.authToken || validTill !== storage.tokenValidTill) {
    let currentExp = Date.parse(storage.tokenValidTill);
    let newExp = Date.parse(validTill);
    if (currentExp && newExp && newExp < currentExp) return;
    let doNotify = authToken !== Auth.authToken;
    Auth.authToken = authToken;
    Auth.isAuthenticated = authToken !== '';
    storage.authToken = authToken;
    storage.tokenValidTill = validTill;
    if (doNotify) Auth.notify();
  }
}

Auth.checkToken = () => {
  // debugger;
  // if (!Auth.isAuthenticated && Auth.ready) return true; /// when just loaded the page
  const authToken = storage.authToken || '';
  const validTill = storage.tokenValidTill && Date.parse(storage.tokenValidTill) ? new Date(storage.tokenValidTill) : 0;
  const now = new Date();
  // console.log('validTill vs now', validTill && validTill.toISOString(), now.toISOString());
  if (authToken && validTill && validTill > now) {
    Auth.updateAuthToken(authToken, validTill.toISOString());
  } else {
    Auth.updateAuthToken('', '');
  }
}

Auth.isReady = () => {
  Auth.checkToken();
  Auth.ready = true;
  return true;
}

Auth.subscribe = (callback) => {
  Auth.subscribers.push(callback);
}

Auth.notify = () => {
  Auth.subscribers.forEach(callback => callback(Auth.isAuthenticated));
}

Auth.authenticate = (email, password) => {
  return new Promise((resolve, reject) => {
    axios.post(prepareUrl('authenticate'), {
      email,
      password,
    }).then((response) => {
      if (response.data.auth_token) {
        Auth.email = email;
        Auth.password = password;
        Auth.updateAuthToken(response.data.auth_token, response.data.exp);
        resolve(true);
      } else {
        Auth.updateAuthToken('');
        reject(response.data.errors);
      }
    }).catch((response) => {
      Auth.updateAuthToken('');
      let message = 'Some Network errors occurred.';
      if (response.response && response.response.status === 401) {
        message = "Неверная пара логин-пароль."
      }
      reject([message]);
    });
  });
}

Auth.refreshToken = () => {
  if (!Auth.isAuthenticated) return Promise.resolve(true);
  
  return new Promise((resolve, reject) => {
    axios.get(prepareUrl('refreshtoken')).then((response) => {
      if (response.data.auth_token) {
        Auth.updateAuthToken(response.data.auth_token, response.data.exp);
        resolve(true);
      } else {
        Auth.authenticate(Auth.email, Auth.password).then(() => resolve(true)).catch((e) => reject(e) );
      }
    }).catch((response) => {
      let message = 'Some Network errors occurred.';
      if (response.response && response.response.status === 401) {
        Auth.authenticate(Auth.email, Auth.password).then(() => resolve(true)).catch((e) => reject(e) );
      } else {
        reject([message]);
      }
    });
  });
}

Auth.signout = () => {
  return new Promise((resolve, reject) => {
    Auth.updateAuthToken('');
    resolve(true);
    Auth.notify();
  });
}


export default Auth;